/**
 * Backend tool fields are JSON-encoded strings in places — a turn that used no
 * tools arrives with aI_Tool/ai_tool set to the literal "[]" (or "{}") instead
 * of being omitted. That is not a real tool name; rendering it verbatim puts a
 * fake "[]" execution in the Run Details panel, so junk names are dropped at
 * every ingestion point and the panel's proper empty state shows instead.
 */
export function isMeaninglessToolName(raw?: string | null): boolean {
  const s = (raw ?? '').trim();
  return !s || s === '[]' || s === '{}' || s === 'null' || s === 'undefined';
}

/**
 * A history entry's aI_Tool is a single string per turn — "[]" when no tools
 * ran, a plain tool name, or a JSON-encoded array of names otherwise.
 */
export function parseAiToolField(raw?: string | null): string[] {
  const s = (raw ?? '').trim();
  if (isMeaninglessToolName(s)) return [];
  if (s.startsWith('[')) {
    try {
      const arr = JSON.parse(s);
      if (Array.isArray(arr)) return arr.map(String).filter(n => !isMeaninglessToolName(n));
    } catch {
      // Not valid JSON — fall through and treat it as a plain tool name.
    }
  }
  return [s];
}
